import {
    FETCH_CONTACTS_ERROR,
    FETCH_CONTACTS_LOADING,
    FETCH_CONTACTS_SUCCESS,

    RESET_CONTACTS,
    FETCH_MORE_CONTACTS_SUCCESS
} from "./index" 

import {apiCall} from "../../functions/utils"

export const fetchContactsSuccess = (data) => {
    return {
        type : FETCH_CONTACTS_SUCCESS,
        payload: data.data,
        meta: data.meta
    }
}

export const fetchMoreContactsSuccess = (data) => {
    return {
        type : FETCH_MORE_CONTACTS_SUCCESS,
        payload: data.data,
        meta: data.meta
    }
}

export const fetchContactsError = (error) => {
    return {
        type : FETCH_CONTACTS_ERROR,
        error
    }
}

export const fetchContactsLoading = () => {
    return {
        type : FETCH_CONTACTS_LOADING
    }
}

export const resetContacts = () => {
    return {
        type : RESET_CONTACTS
    }
}

export const fetchMoreContacts = (query = "",meta = false) => {  
    return async (dispatch, getState) => {
        let page = 1;
        if( !meta ){
            meta = getState().contacts.meta
        }
        if(meta){
            if( meta.current_page < meta.last_page){
                page = meta.current_page + 1 
                dispatch(fetchContactsLoading())
                try{
                    const res = await apiCall(true, "GET", `/api/contacts?query=${query}&page=${page}`)
                    dispatch(fetchMoreContactsSuccess(res.data))
                }catch(e){
                    dispatch(fetchContactsError(e))
                } 
            }
        }
    } 
}

//ff_
export const fetchContacts = (query = "", page = 1, tags = false) => {
    let tagId=""
    if(tags){
        tagId=tags.id
    }
    return async (dispatch) => {
        dispatch(fetchContactsLoading())
        try{
            const res = await apiCall(true, "GET", `/api/contacts?query=${query}&page=${page}&tag=${tagId}`)
            dispatch(fetchContactsSuccess(res.data))
        }catch(e){
            dispatch(fetchContactsError(e))
        } 
    }
}



export const deleteContact = ( contact, query = "" ) => {
    return async (dispatch) => {
        dispatch(fetchContactsLoading())
        try{
            const res = await apiCall(true, "DELETE", `/api/contacts/${contact.id}` )
            dispatch(fetchContacts(query))
        }catch(e){
            dispatch(fetchContactsError(e))
        } 
    }
}

export const createContact = ( contact, query = "" ) => {
    return async (dispatch) => {
        dispatch(fetchContactsLoading())
        try{
            const res = await apiCall(true, "POST", `/api/contacts`, contact )
            dispatch(fetchContacts(query))
        }catch(e){
            dispatch(fetchContactsError(e))
        } 
    }
}

export const editContact = ( contact, query = "" ) => {
    return async (dispatch) => {
        dispatch(fetchContactsLoading())
        try{
            const res = await apiCall(true, "PUT", `/api/contacts/${contact.id}`, contact )
            dispatch(fetchContacts(query))
        }catch(e){
            dispatch(fetchContactsError(e))
        } 
    }
}
